import { Progress } from "antd"
import type React from "react"

interface ProgressBarChartProps {
  percentageValue: number
  width?: number
  height?: number
  size?: number
  label?: any
  labelAbove?: string
  multicolor?: boolean
  multicolorInverted?: boolean
  color?: string
}

const ProgressBarChart: React.FC<ProgressBarChartProps> = ({
  percentageValue,
  width,
  height,
  label,
  labelAbove,
  size,
  multicolor = false,
  multicolorInverted = false,
  color,
}) => {
  const getColor = () => {
    if (percentageValue >= 75) {
      return "#209E70"
    } else if (percentageValue < 50) {
      return "#D34444"
    } else {
      return "#DFA144"
    }
  }

  const getInvertedColor = () => {
    if (percentageValue >= 75) return "#D34444" 
    if (percentageValue >= 50) return "#DFA144"
    return "#209E70"
  }

  console.log("percentageValue:", percentageValue, "multicolorInverted:", multicolorInverted)

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "200px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Label Above */}
      {labelAbove && (
        <div
          style={{
            marginBottom: 8,
            color: "#282B34",
            wordBreak: "break-word",
            fontSize: "16px",
            textAlign: "center",
            lineHeight: "20px",
            minHeight: "20px",
            width: "100%",
          }}
        >
          {typeof labelAbove === "string" ? labelAbove : labelAbove}
        </div>
      )}

      {/* Progress Bar Container */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        {multicolor || multicolorInverted ? (
          <Progress
            percent={percentageValue > 100 ? 100 : percentageValue}
            strokeColor={multicolorInverted ? getColor() : getInvertedColor()}
            strokeWidth={8}
            size={size || width || 120}
            type="dashboard"
            format={() =>
              percentageValue > 100 ? (
                <span style={{ color: "#D34444", fontWeight: 600 }}>NA</span>
              ) : (
                <span
                  style={{
                    color: "#282B34",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                >
                  {percentageValue}%
                </span>
              )
            }
          />
        ) : (
          <Progress
            percent={percentageValue > 100 ? 100 : percentageValue}
            strokeColor={color || "#209E70"}
            strokeWidth={8}
            size={size || width || 120}
            type="dashboard"
            format={() =>
              percentageValue > 100 ? (
                <span style={{ color: "#282B34", fontWeight: 600 }}>NA</span>
              ) : (
                <span
                  style={{
                    color: "#282B34",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                >
                  {percentageValue}%
                </span>
              )
            }
          />
        )}
      </div>

      {/* Label Below */}
      {label && (
        <div
          style={{
            marginTop: 8,
            color: "#282B34",
            wordBreak: "break-word",
            fontSize: "13px",
            textAlign: "center",
            lineHeight: "16px",
            minHeight: "32px",
            width: "100%",
          }}
        >
          {typeof label === "string" ? label : label}
        </div>
      )}
    </div>
  )
}

export default ProgressBarChart
